import { trackEvent } from '../usePageTracking'

/**
 * 「このブラウザでは初回アップロードを数え終わっている」ことを覚えるキー。
 *
 * サーバに「その利用者の通算アップロード枚数」を問い合わせる専用 API は無く、
 * クライアントから本当の初回かどうかは判定できない。localStorage はブラウザ単位で
 * 利用者に紐づかないので、同じ端末を2人で使えば2人目は数えられず、1人が2台使えば
 * 2回数える。実態と一致しない可能性が残る指標なので、イベント名も
 * first_photo_upload ではなく _browser 付きにして「このブラウザから見た初回」で
 * あることを名前に残している（_client だと、同じく写真をアップロードするデスクトップ
 * アプリ client/ からの初回と読めてしまう。client/ は GA4 を一切送っていない）。
 */
const storage_key = 'first_photo_upload_tracked'

/** 印が付いているか。localStorage が使えない環境では「付いている」= 数えない側に倒す */
const isMarked = () => {
  try {
    return localStorage.getItem(storage_key) !== null
  } catch {
    return true
  }
}

/** 印を付けられたら true。付けられなければ二重送信を防ぐため false */
const mark = () => {
  try {
    localStorage.setItem(storage_key, '1')
    return true
  } catch {
    return false
  }
}

/**
 * 既に写真を持っている利用者を計測対象から外す。
 *
 * これが無いと、計測を入れた時点で既存利用者が次のアップロードで一斉に
 * first_photo_upload_browser を出し、新規利用者のアクティベーションを表すはずの
 * 指標がリリース直後だけ跳ね上がって読めなくなる。me（getMe）は起動時に取れるので、
 * 保有枚数が1枚以上ならイベントを出さずに印だけ付けておく。
 *
 * ただし MeSideEffects が渡す storage_used_count_files は openapi.yaml の定義上
 * 「現在ストレージを使っている写真の枚数」であり、通算アップロード枚数ではない。
 * 過去にアップロードした写真を全部消した利用者は 0 のまま印が付かず、次のアップロードで
 * 初回でないのに first_photo_upload_browser が出る。この分の過大計上は残る。
 */
export const markPhotoUploadHistory = (uploaded_count: number) => {
  if (uploaded_count <= 0 || isMarked()) return
  mark()
}

/** このブラウザで初回のアップロード成功なら1度だけ計測する */
export const trackFirstPhotoUploadSuccess = () => {
  if (isMarked()) return
  if (!mark()) return
  trackEvent('first_photo_upload_browser')
}
